/**
 * Configuration file for the application
 */

/**
 * Server configuration
 */
const server = {
  hostname: "localhost",
  port: 3000,
};

/**
 * Excluded paths from redirection
 */
const excludedPaths = [
  "/_next",
  "/api",
  "/assets",
  "/tmp",
  "/favicon.ico",
  "/socket.io",
];

/**
 * Public paths
 */

const protectedPath = ["/dashboard", "/projects", "/settings", "/users"];

module.exports = {
  server,
  excludedPaths,
  protectedPath,
};
